/* eslint-disable no-undef */
import { CurrentConditionsWidget } from './currentConditionsWidget';

const props = [];

export const CurrentConditionsWidgetDirective = (reactDirective) => reactDirective(CurrentConditionsWidget, props);
CurrentConditionsWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('currentConditionsWidget', CurrentConditionsWidgetDirective);
